<template>
  <div class="uiElement-settings" v-if="!serversLoading">
    <div class="columns">
      <div class="column is-4">
        <edit-button :editOptions="['save']" @click="save" :disabled="saving">
          <template>
            <span class="text">{{ $t('ui_settings.save') }}</span>
          </template>
        </edit-button>
        <div class="element-config">
          <div class="description" v-html="configs.description"></div>
          <parametrs-list
            v-if="isRenderParametrs"
            :items.sync="configs.parameters"
            :parameters="configs.properties.parameters"
            :disabled="false"
            @draw="drawConfig($event, key)"
          >
          </parametrs-list>
        </div>

        <div class="element-config" v-if="this.configs.properties.fields">
          <h1 class="element-config-title">{{ $t('ui_settings.fields') }}</h1>
          <draggable :list="configs.fields" class="uiElements" handle=".handle" @change="movedField">
            <div v-for="(element, key) in configs.fields" :key="key" class="uiElement">
              <div class="header fields" :class="[element.type, { inactive: element.is_active }]">
                <div
                  class="name"
                  @click="
                    element.expand = !element.expand
                    $forceUpdate()
                  "
                >
                  <i class="fas fa-grip-vertical handle"></i>
                  <span class="title">
                    {{ element.displayed_name || $t('ui_settings.field') }}
                    <span v-if="element.isNew">&nbsp;(new)</span>
                  </span>
                </div>
                <div class="actions">
                  <i
                    @click="changeMonitoredField(key)"
                    v-show="element.is_active && !element.isNew"
                    :class="{
                      'fas fa-eye': monitoredField == key,
                      'fas fa-eye unmonitored': monitoredField != key
                    }"
                  ></i>
                  <i class="fas fa-trash-alt" @click="removeField(key)"></i>
                </div>
              </div>
              <div class="body" :disabled="false" v-show="element.expand">
                <div class="description" v-html="element.description"></div>
                <parametrs-list
                  v-if="isRenderParametrs"
                  :items.sync="element.parameters"
                  :parameters="configs.properties.fields.parameters"
                  :disabled="false"
                  @draw="draw($event, key)"
                >
                </parametrs-list>
              </div>
            </div>
          </draggable>
          <edit-button class="add-new" :position="null" :editOptions="['addField']" @click="addField()">
            <template>
              <span class="text">
                {{ $t('ui_settings.addField') }}
              </span>
            </template>
          </edit-button>
        </div>

        <div class="element-config" v-if="this.configs.properties.buttons">
          <h1 class="element-config-title">{{ $t('ui_settings.buttons') }}</h1>
          <draggable :list="configs.buttons" class="uiElements" handle=".handle" @change="movedButton">
            <div v-for="(element, key) in configs.buttons" :key="key" class="uiElement">
              <div class="header fields" :class="[element.type, { inactive: element.is_active }]">
                <div
                  class="name"
                  @click="
                    element.expand = !element.expand
                    $forceUpdate()
                  "
                >
                  <i class="fas fa-grip-vertical handle"></i>
                  <span class="title">
                    {{ element.displayed_name || $t('ui_settings.button') }}
                    <span v-if="element.isNew">&nbsp;(new)</span>
                  </span>
                </div>
                <div class="actions">
                  <i
                    @click="changeMonitoredButton(key)"
                    v-show="element.is_active && !element.isNew"
                    :class="{
                      'fas fa-eye': monitoredButton == key,
                      'fas fa-eye unmonitored': monitoredButton != key
                    }"
                  ></i>
                  <i class="fas fa-trash-alt" @click="removeButton(key)"></i>
                </div>
              </div>
              <div class="body" :disabled="false" v-show="element.expand">
                <div class="description" v-html="element.description"></div>
                <parametrs-list
                  v-if="isRenderParametrs"
                  :items.sync="element.parameters"
                  :parameters="configs.properties.buttons.parameters"
                  :disabled="false"
                  @draw="draw($event, key)"
                >
                </parametrs-list>
              </div>
            </div>
          </draggable>
          <edit-button class="add-new" :position="null" :editOptions="['addButton']" @click="addButton()">
            <template>
              <span class="text">
                {{ $t('ui_settings.addButton') }}
              </span>
            </template>
          </edit-button>
        </div>

        <div class="element-config" v-if="this.configs.properties.filters">
          <h1 class="element-config-title">{{ $t('ui_settings.filters') }}</h1>
          <draggable :list="configs.filters" class="uiElements" handle=".handle" @change="movedFilter">
            <div v-for="(element, key) in configs.filters" :key="key" class="uiElement">
              <div class="header filters" :class="[element.type, { inactive: element.is_active }]">
                <div
                  class="name"
                  @click="
                    element.expand = !element.expand
                    $forceUpdate()
                  "
                >
                  <i class="fas fa-grip-vertical handle"></i>
                  <span class="title">
                    {{ element.displayed_name || $t('ui_settings.filter') }}
                    <span v-if="element.isNew">&nbsp;(new)</span>
                  </span>
                </div>
                <div class="actions">
                  <i
                    @click="changeMonitoredFilter(key)"
                    v-show="element.is_active && !element.isNew"
                    :class="{
                      'fas fa-eye': monitoredFilter == key,
                      'fas fa-eye unmonitored': monitoredFilter != key
                    }"
                  ></i>
                  <i class="fas fa-trash-alt" @click="removeFilter(key)"></i>
                </div>
              </div>
              <div class="body" :disabled="false" v-show="element.expand">
                <div class="description" v-html="element.description"></div>
                <parametrs-list
                  v-if="isRenderParametrs"
                  :items.sync="element.parameters"
                  :parameters="configs.properties.filters.parameters"
                  :disabled="false"
                  @draw="draw($event, key)"
                >
                </parametrs-list>
              </div>
            </div>
          </draggable>
          <edit-button class="add-new" :position="null" :editOptions="['addFilter']" @click="addFilter()">
            <template>
              <span class="text">
                {{ $t('ui_settings.addFilter') }}
              </span>
            </template>
          </edit-button>
        </div>
      </div>
      <div class="column is-8">
        <actions position="is-bottom-left">
          <template>
            <b-dropdown-item @click="toDuplicate" aria-role="listitem">{{ $t('lists.duplicate') }}</b-dropdown-item>
            <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{
              $t('server.actions.delete')
            }}</b-dropdown-item>
          </template>
        </actions>
        <div class="uiElement-details">
          <dashboard-widget
            :settings="configs"
            :elementData="elementData"
            :dashboardId="$route.query.dashboard_id"
          ></dashboard-widget>
        </div>
      </div>
    </div>
  </div>
  <loader v-else></loader>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import EditButton from '@/components/EditButton'
import Actions from '@/components/Actions'
import Loader from '@/components/Loader'
import ParametrsList from '@/components/ParametrsList'
import draggable from 'vuedraggable'
import DashboardWidget from '@/components/DashboardWidget'
const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'UiElement',
  components: {
    draggable,
    EditButton,
    Actions,
    ParametrsList,
    Loader,
    DashboardWidget
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role,
      title: state => state.title
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      configs: {},
      serversLoading: false,
      saving: false,
      elementData: null,
      monitoredFilter: 0,
      monitoredField: 0,
      monitoredButton: 0,
      isRemoveButtonClickedAt: 0,
      isRemoveFieldClickedAt: 0,
      isRemoveFilterClickedAt: 0,
      isRenderParametrs: true
    }
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push({
        name: 'ui_settings'
      })
    }
    this.getDefaultConfig()
  },
  methods: {
    ...mapActions('general', ['setTitle', 'setUiElementName', 'setDashboardName']),
    toDuplicate() {
      this.$router.push({
        name: 'add_ui_element',
        query: {
          duplicate: this.$route.params.ui_element_id,
          dashboard_id: this.$route.query.dashboard_id
        }
      })
    },
    duplicate() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_element/duplicate`
      this.serversLoading = true
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          dashboard_id: this.$route.query.dashboard_id,
          ui_element_id: this.$route.query.duplicate
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.configs = data.config
          this.elementData = data.ui_element_data
          this.setTitle(this.configs.name)
          this.setUiElementName(this.configs.name)
          if (data.dashboard) {
            this.setDashboardName(data.dashboard.name)
          }
          this.monitorLastActiveButton()
          this.monitorLastActiveFilter()
          this.monitorLastActiveField()
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.serversLoading = false
        })
    },
    getDefaultConfig() {
      if (!this.serversLoading) {
        if (this.$route.name === 'add_ui_element' && this.$route.query.duplicate != undefined) {
          return this.duplicate()
        }
        const body = {}
        if (this.$route.query.type !== undefined) {
          body.type = this.$route.query.type
        }
        if (this.$route.query.dashboard_id !== undefined) {
          body.dashboard_id = this.$route.query.dashboard_id
        }
        if (this.$route.params.ui_element_id !== undefined) {
          body.ui_element_id = this.$route.params.ui_element_id
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_element?${searchParams}`
        this.serversLoading = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.configs = data.config
            this.elementData = data.ui_element_data
            if (!this.configs.name) {
              this.configs.name = this.title
            } else {
              this.setTitle(this.configs.name)
              this.setUiElementName(this.configs.name)
            }
            if (data.dashboard) {
              this.setDashboardName(data.dashboard.name)
            }
            this.monitorLastActiveButton()
            this.monitorLastActiveFilter()
            this.monitorLastActiveField()
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    save() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_element`
      this.saving = true
      this.configs.name = this.title
      if (this.configs.fields) {
        // eslint-disable-next-line no-unused-vars
        this.configs.fields = this.configs.fields.map(({ is_active, ...keepAttrs }) => keepAttrs)
      }
      if (this.configs.filters) {
        // eslint-disable-next-line no-unused-vars
        this.configs.filters = this.configs.filters.map(({ is_active, ...keepAttrs }) => keepAttrs)
      }
      if (this.configs.buttons) {
        // eslint-disable-next-line no-unused-vars
        this.configs.buttons = this.configs.buttons.map(({ is_active, ...keepAttrs }) => keepAttrs)
      }
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          dashboard_id: this.$route.params.dashboard_id,
          ui_element_config: this.configs
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.$notify({
            message: this.$t('ui_settings.saved'),
            type: 'success'
          })
          if (this.$route.name === 'add_ui_element') {
            const query = {}
            if (this.$route.query.dashboard_id) {
              query['dashboard_id'] = this.$route.query.dashboard_id
            }
            this.$router.push({
              name: 'edit_ui_element',
              params: {
                ui_element_id: data.id
              },
              query
            })
          } else {
            this.getDefaultConfig()
          }
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.saving = false
        })
    },
    deleteUiElement() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/ui_settings/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          ui_element_ids: [this.$route.params.ui_element_id]
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.removed', {
              msg: this.configs.name
            }),
            type: 'success'
          })
          if (this.$route.query.dashboard_id) {
            this.$router.push({
              name: 'dashboard',
              params: {
                dashboard_id: this.$route.query.dashboard_id
              }
            })
          } else {
            this.$router.push({
              name: 'ui_settings'
            })
          }
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: this.configs.name
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteUiElement().finally(() => {
            this.serversLoading = false
          })
        }
      })
    },
    movedFilter(event) {
      if (event.moved.oldIndex == this.monitoredFilter) {
        this.monitoredFilter = event.moved.newIndex
      } else if (event.moved.newIndex == this.monitoredFilter) {
        if (this.monitoredFilter > event.moved.oldIndex) {
          this.monitoredFilter -= 1
        } else {
          this.monitoredFilter += 1
        }
      }
      this.isRenderParametrs = false
      return this.$nextTick(() => (this.isRenderParametrs = true))
    },
    removeFilter(key) {
      if (Date.now() - this.isRemoveFilterClickedAt < 500) {
        return
      }
      this.isRemoveFilterClickedAt = Date.now()

      this.configs.filters.splice(key, 1)
      if (key == this.monitoredFilter) {
        this.monitorLastActiveFilter()
      } else if (key < this.monitoredFilter) {
        this.monitoredFilter -= 1
      }
      this.$forceUpdate()
    },
    monitorLastActiveFilter() {
      if (!this.configs.filters) {
        return
      }
      this.monitoredFilter = -1
      for (let i = this.configs.filters.length - 1; i >= 0; --i) {
        if (this.configs.filters[i].is_active && !this.configs.filters[i].isNew) {
          this.monitoredFilter = i
          break
        }
      }
    },
    addFilter() {
      this.configs.filters.push({
        isNew: true,
        is_active: true,
        id: this.configs.properties.filters.id,
        expand: this.configs.properties.filters.expand,
        parameters: this.configs.properties.filters.parameters.reduce(function(map, item) {
          map[item.name] = item.default_value
          return map
        }, {})
      })
    },
    movedField(event) {
      if (event.moved.oldIndex == this.monitoredField) {
        this.monitoredField = event.moved.newIndex
      } else if (event.moved.newIndex == this.monitoredField) {
        if (this.monitoredField > event.moved.oldIndex) {
          this.monitoredField -= 1
        } else {
          this.monitoredField += 1
        }
      }
      this.isRenderParametrs = false
      return this.$nextTick(() => (this.isRenderParametrs = true))
    },
    removeField(key) {
      if (Date.now() - this.isRemoveFieldClickedAt < 500) {
        return
      }
      this.isRemoveFieldClickedAt = Date.now()

      this.configs.fields.splice(key, 1)
      if (key == this.monitoredField) {
        this.monitorLastActiveField()
      } else if (key < this.monitoredField) {
        this.monitoredField -= 1
      }
      this.$forceUpdate()
    },
    monitorLastActiveField() {
      if (!this.configs.fields) {
        return
      }
      this.monitoredField = -1
      for (let i = this.configs.fields.length - 1; i >= 0; --i) {
        if (this.configs.fields[i].is_active && !this.configs.fields[i].isNew) {
          this.monitoredField = i
          break
        }
      }
    },
    addField() {
      this.configs.fields.push({
        isNew: true,
        is_active: true,
        id: this.configs.properties.fields.id,
        expand: this.configs.properties.fields.expand,
        parameters: this.configs.properties.fields.parameters.reduce(function(map, item) {
          map[item.name] = item.default_value
          return map
        }, {})
      })
    },
    movedButton(event) {
      if (event.moved.oldIndex == this.monitoredButton) {
        this.monitoredButton = event.moved.newIndex
      } else if (event.moved.newIndex == this.monitoredButton) {
        if (this.monitoredButton > event.moved.oldIndex) {
          this.monitoredButton -= 1
        } else {
          this.monitoredButton += 1
        }
      }
      this.isRenderParametrs = false
      return this.$nextTick(() => (this.isRenderParametrs = true))
    },
    removeButton(key) {
      if (Date.now() - this.isRemoveButtonClickedAt < 500) {
        return
      }
      this.isRemoveButtonClickedAt = Date.now()

      this.configs.buttons.splice(key, 1)
      if (key == this.monitoredButton) {
        this.monitorLastActiveButton()
      } else if (key < this.monitoredButton) {
        this.monitoredButton -= 1
      }
      this.$forceUpdate()
    },
    monitorLastActiveButton() {
      if (!this.configs.buttons) {
        return
      }
      this.monitoredButton = -1
      for (let i = this.configs.buttons.length - 1; i >= 0; --i) {
        if (this.configs.buttons[i].is_active && !this.configs.buttons[i].isNew) {
          this.monitoredButton = i
          break
        }
      }
    },
    addButton() {
      this.configs.buttons.push({
        isNew: true,
        is_active: true,
        id: this.configs.properties.buttons.id,
        expand: this.configs.properties.buttons.expand,
        parameters: this.configs.properties.buttons.parameters.reduce(function(map, item) {
          map[item.name] = item.default_value
          return map
        }, {})
      })
    }
  }
}
</script>

<style lang="scss">
.uiElement-settings {
  .element-config {
    margin-top: 0.9rem;
    margin-bottom: 1rem;
    //padding: 1rem;
    //border: 0.0625rem solid #ccc;
    .element-config-title {
      font-weight: 900;
      font-size: 1.5rem;
    }
  }
  .visual-drawing {
    position: relative;
    width: 100%;
    &.zoomable {
      cursor: grab;
    }
    .visual-sample {
      object-fit: contain;
      max-height: 80vh;
    }
    .canvas-container {
      position: absolute !important;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0;
    }
  }
  .field.is-grouped.is-buttons-under-canvas {
    .control {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .uiElements {
    float: left;
    width: 100%;
    margin-top: 1rem;
    margin-bottom: 1rem;
    &.advance {
      margin-top: 0;
      .uiElement {
        .header .name {
          cursor: unset;
          span {
            display: block;
            padding: 0.5rem;
            padding-top: 0.444rem;
            padding-bottom: 0.444rem;
          }
        }
        .body {
          .save {
            display: flex;
            margin-top: 1rem;
            .flex {
              flex: auto;
            }
            .button {
              font-size: 0.9rem;
              color: #4bbd4d;
              border-color: #4bbd4d;
              border-radius: 0.3125rem;
              font-weight: bold;
              padding-right: 0.625rem;
              padding-left: 0.625rem;
              height: 1.25rem;
            }
          }
        }
      }
    }
    .uiElement {
      margin-bottom: 0.8rem;
      &:last-child {
        margin: 0;
      }
      &.sortable-ghost {
        .header {
          .name {
            opacity: 0;
          }
          .actions {
            opacity: 0;
          }
        }
        .body {
          display: none;
        }
      }
      .header {
        border: 0.0625rem solid #ccc;
        background-color: #969696;

        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;

        &.fields {
          background-color: #59adff;
        }
        &.filters {
          background-color: #fc4850;
        }
        &.output {
          background-color: #b032e7;
        }
        &.inactive {
          background-color: #d0d0d0;
          color: #777;
        }

        .name {
          cursor: pointer;
          flex: auto;
          .title {
            font-size: 0.9rem;
            padding-top: 0.444rem;
            padding-bottom: 0.444rem;
            height: 100%;
            display: block;
          }
          i.handle {
            padding: 0.5rem;
            cursor: grab;
            display: block;
            float: left;
            height: 100%;
          }
        }
        .actions {
          display: flex;
          .switch {
            display: flex;
            align-items: unset;
            padding-top: 0.4rem;
            .control-label {
              display: none;
            }
            input {
              display: none;
            }
          }
          i {
            cursor: pointer;
            padding: 0.5rem;
            &.unmonitored {
              opacity: 0.2;
            }
          }
        }
      }
      .body {
        padding: 1rem;
        border: 0.0625rem solid #ccc;
        border-top: 0;
        .description {
          margin-bottom: 1rem;
        }
      }
    }
  }
  .add-new {
    button.add {
      .text {
        padding-left: 1.25rem;
        padding-right: 1.25rem;
      }
    }
    .dropdown-menu {
      width: 100%;
    }
  }
  .actions {
    float: right;
  }
  .uiElement-details {
    float: left;
    width: 100%;
    margin-top: 1rem;
    min-height: 12rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .video {
      border: 0.0625rem solid #ccc;
      display: flex;
      margin-bottom: 0.8rem;
      overflow: hidden;
      .video-data {
        display: flex;
      }
    }
    .server-info {
      padding: 1rem;
      border: 0.0625rem solid #ccc;
      display: flex;
      margin-bottom: 0.8rem;
      &.widget {
        padding: 0;
        position: relative;
        display: grid;
        .details {
          padding: 1rem;
          width: 100%;
          margin-bottom: 1rem;
          overflow: auto;
        }
        i {
          width: 1.5rem;
          height: 1.5rem;
          position: absolute;
          bottom: 0;
          right: 0;
          cursor: ns-resize;
        }
      }
      .description {
        flex: auto;
        .source-name {
          height: 2rem;
          .name {
            color: #62b1ff;
            font-weight: bold;
          }
        }
        .button {
          font-size: 0.9rem;
          color: #4bbd4d;
          border-color: #4bbd4d;
          border-radius: 0.3125rem;
          font-weight: bold;
          padding-right: 0.625rem;
          padding-left: 0.625rem;
          height: 1.25rem;
        }
      }
      .actions {
        .buttons {
          margin: 0;
          .button {
            border: 0;
            padding: 0;
            margin-left: 0.5rem;
            height: max-content;
            color: #686868;
            background-color: #fff;
            font-size: 1.5rem;
            &.forward {
              .forward {
                display: contents;
              }
            }
            &.play {
              &.active {
                color: #4bbd4d;
              }
            }
            &.stop {
              &.active {
                color: #fc4850;
              }
            }
          }
          .indicator {
            width: 100%;
            display: block;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
